import { AppstoreOutlined, InboxOutlined } from '@ant-design/icons';
import type { ProdutoBodyEstoque } from '@/features/produto/types/ProdutoBody';

export function ProdutoTabEstoqueLocalResumo({
    agruparPorLocal,
    estoqueTotal,
    produtoEstoque,
    quantidadeLocais,
    unidade,
}: {
    agruparPorLocal?: boolean;
    estoqueTotal?: number | null;
    produtoEstoque: ProdutoBodyEstoque[];
    quantidadeLocais: number;
    unidade: string;
}) {
    const estoqueAtualPorLocal = produtoEstoque.reduce((estoquePorLocal, estoque) => {
        const localId = estoque.pre_estoque_idpk ?? 'sem-local';
        const estoqueAtual = estoquePorLocal.get(localId) ?? 0;

        estoquePorLocal.set(localId, estoqueAtual + (estoque.pre_estoque_atual ?? 0));

        return estoquePorLocal;
    }, new Map<number | string, number>());

    const quantidadeLocaisComEstoque = agruparPorLocal
        ? [...estoqueAtualPorLocal.values()].filter((estoqueAtual) => estoqueAtual > 0).length
        : produtoEstoque.filter((estoque) => (estoque.pre_estoque_atual ?? 0) > 0).length;

    const totalLocais = agruparPorLocal ? estoqueAtualPorLocal.size : quantidadeLocais;

    const totalAtual =
        estoqueTotal ??
        produtoEstoque.reduce((total, estoque) => total + (estoque.pre_estoque_atual ?? 0), 0);

    const totalReservado = produtoEstoque.reduce(
        (total, estoque) => total + (estoque.pre_estoque_reservado ?? 0),
        0,
    );

    const totalDisponivel = totalAtual - totalReservado;

    return (
        <div className='mt-3 grid gap-3 rounded-md border border-blue-200 bg-blue-50 p-4 text-blue-700 sm:grid-cols-2 lg:grid-cols-4'>
            <div className='flex items-center gap-3'>
                <AppstoreOutlined className='text-2xl' />
                <div>
                    <div className='text-xs text-gray-600'>Locais de estoque</div>
                    <strong className='text-xl'>
                        {quantidadeLocaisComEstoque} / {totalLocais}
                    </strong>
                </div>
            </div>

            <div className='flex items-center gap-3'>
                <InboxOutlined className='text-2xl' />
                <div>
                    <div className='text-xs text-gray-600'>Total em estoque</div>
                    <strong className='text-xl'>
                        {totalAtual} {unidade}
                    </strong>
                </div>
            </div>

            <div>
                <div className='text-xs text-gray-600'>Reservado</div>
                <strong className='text-xl'>
                    {totalReservado} {unidade}
                </strong>
            </div>

            <div>
                <div className='text-xs text-gray-600'>Disponível</div>
                <strong className='text-xl'>
                    {totalDisponivel} {unidade}
                </strong>
            </div>
        </div>
    );
}
